// ------------------------------------
// props 輸入需求 :
// props.setReset : function( params: boolean )         ( 回傳true --> 重刷畫面 )
// ------------------------------------


import React, { useState, useEffect, useLayoutEffect } from 'react'
import { useTranslation } from "react-i18next"; // 1.1 i18n
import Account from '../../actions/Account';
import ApiGo from '../../actions/ApiGo';
import { loginStore } from '../../comm_stores';
import { resources } from '../../i18n';
import Dropdown from '../dropdown/Dropdown';
import GoogleAuth, { GoogleSDKLogout } from './GoogleSDK';
import '../epmed/EpMobile/_ep.scss'

const date = new Date();
const year = date.getFullYear()
const markC = "©"

const DEVICES = new Account().get_user_devices()

const LoginMobile =(props)=>{
    // i18n 組合
    const { t, i18n } = useTranslation(); // 1.2 i18n
    const lng_choice = Object.entries(resources).map( res=> res[1].title)
    lng_choice.unshift(t('GLOBAL.CHANGE_LANGUAGE'))
    const DP_data = {id:lng_choice[0], keys:lng_choice}
    const [returnLng, setReturnLng] = useState("");     //dropdown return result
    // language 存為預設
    function storeLanguageToStorage(lng) {
        localStorage.setItem("i18nextLng", lng)
        sessionStorage.setItem("i18nextLng", lng)
    }
    // language 修改
    useEffect(()=>{
        let result = Object.entries(resources).filter( res=>res[1].title === returnLng )[0]
        if(result!==undefined){
            storeLanguageToStorage(result[0])
            i18n.changeLanguage(result[0])
        }
    }, [returnLng, i18n])

    const [thirdPartyTag, setThirdPartyTag] = useState(false);

    // 帳密輸入組合
    const [account, setAccount] = useState("");
    const [password, setPassword] = useState("");
    const [clickAccount, setClickAccount] = useState(false);
    const [clickPassword, setClickPassword] = useState(false);

    // 輸入錯誤帳號密碼
    const [storeLogin, setStoreLogin] = useState(loginStore.getState());
    const [wrongAccOrPwd, setWrongAccOrPwd] = useState(false);
    loginStore.subscribe(() =>setStoreLogin(loginStore.getState()));
    useEffect(()=>{
        if (storeLogin.status==="denied") setWrongAccOrPwd(true)
    },[storeLogin])

    // fetch api
    function login(event) {
        if(event.key==="Enter" || event==="Enter"){
            new Account().login(account, password)
        }
    }

    // dropdown 組合
    const [dropdown_open, setDropdown_open] = useState(false);
    function toggleDropdown() { setDropdown_open(!dropdown_open) }
    const [LOGOimg, setLOGOimg] = useState(null);
    const [orign_LOGOimgWH, setOrign_LOGOimgWH] = useState([]);

    useLayoutEffect(()=>{
        ApiGo.getInstitution_img()
        .then(res=>{
            if(res.LogoImg.exist!==""){
                setLOGOimg(res.LogoImg.exist)
                setOrign_LOGOimgWH([res.LogoImg.width, res.LogoImg.height])
            }
        })
        .catch(err=>{console.log(err);})
    }, [])


    return(
        <div className="LoginEp fx-d-c fx-ccc">
            {/* 登入 */}
            {/* <div className="col-3 "></div> */}
            <div className="fx-cfe h-30 w-100">
                {(LOGOimg===null || LOGOimg===undefined)?
                    <div className='empty-logoImg moblePic' data-content={t("GLOBAL.LOGOIMG")}>
                        <div className='bdr-dashed lt'></div>
                        <div className='bdr-dashed rt'></div>
                        <div className='bdr-dashed lb'></div>
                        <div className='bdr-dashed rb'></div>
                    </div>:
                    <img src={LOGOimg}
                        style={{width:`150px`, height:`150px`}}
                        alt='Schematic diagram'/>}
            </div>
            <div className="thirdParty mobile fx-d-c fx-ccc inputBox">
                <div className='w-100 fx-cspar font-ml thirdPartyTag outer tp l r'>
                    <div className={`fx-ccc outer_active l ${thirdPartyTag? 'dismiss':''}`}
                        onClick={()=>{setThirdPartyTag(false)}}>
                        <div className={`fx-ccc l ${thirdPartyTag? '':'inner_active'}`}>帳號登入</div>
                    </div>
                    <div className={`fx-ccc outer_active r ${thirdPartyTag? '':'dismiss'}`}
                        onClick={()=>{setThirdPartyTag(true)}}>
                        <div className={`fx-ccc r ${thirdPartyTag? 'inner_active':''}`}>第三方登入</div>
                    </div>
                </div>
                {/* account */}
                {thirdPartyTag?<>
                    {/* <FBSDK /> */}
                    <div className='outer col-2 fx-ccc outer'><GoogleAuth /></div>
                    <div className='outer col-2 fx-ccc outer'><GoogleSDKLogout /></div>
                </>:<>
                <div className="font-l col-2 fx-ccc outer">
                    <div className="w-90 bd-rad-lr bd-black pad-5 b t account_pointer"
                        onMouseEnter={()=>{setWrongAccOrPwd(false)}}
                        onFocus={()=>{setClickAccount(true); setWrongAccOrPwd(false)}}
                        onKeyDown={()=>{setClickAccount(true)}}
                        onMouseLeave={()=>{ if(account===""){setClickAccount(false)}}}>
                        {(wrongAccOrPwd && storeLogin.responseState!==0)?
                            (storeLogin.responseState===422)?
                                <div className={` ${(wrongAccOrPwd)? "wrong-pwd":""}`}>{t("GLOBAL.ACC_PWD_ERR")}</div>
                            :(storeLogin.responseState===404)?
                                <div className={` ${(wrongAccOrPwd)? "wrong-pwd":""}`}>該帳號已被登出</div>
                                :<div className={` ${(wrongAccOrPwd)? "wrong-pwd":""}`}>{t("GLOBAL.SERVER_CONNECTION_ERR")}</div>
                        :<>
                            {clickAccount?null:<div className={`email_input`}>{t("GLOBAL.ACCOUNT")}</div>}
                            <input type="text"
                            value={account}
                            onChange={e=>setAccount(e.target.value)}
                            className="w-75"/>
                        </>
                        }
                    </div>
                </div>

                {/* password */}
                <div className="font-l col-2 fx-ccc outer">
                    <div className='w-90 bd-rad-lr bd-black pad-5 b t account_pointer'
                        onMouseEnter={()=>{setWrongAccOrPwd(false)}}
                        onFocus={()=>{setClickPassword(true); setWrongAccOrPwd(false) }}
                        onKeyDown={(e)=>{setClickPassword(true); login(e)}}
                        onMouseLeave={()=>{ if(password===""){setClickPassword(false)}}}
                        >
                        {(wrongAccOrPwd && storeLogin.responseState!==0)?
                            (storeLogin.responseState===422)?
                            <div className={` ${(wrongAccOrPwd)? "wrong-pwd":""}`}>{t("GLOBAL.ACC_PWD_ERR")}</div>
                            :(storeLogin.responseState===404)?
                            <div className={` ${(wrongAccOrPwd)? "wrong-pwd":""}`}>該帳號已被登出</div>
                            :<div className={` ${(wrongAccOrPwd)? "wrong-pwd":""}`}>{t("GLOBAL.SERVER_CONNECTION_ERR")}</div>
                        :<>
                            {clickPassword?null:<div className={`email_input type`}>{t("GLOBAL.PASSWORD")}</div>}
                            <input type="password"
                            value={password}
                            onChange={e=>setPassword(e.target.value)}
                            className="w-75"/>
                        </>}
                    </div>
                </div>
                </>}
                {/* login */}
                <div className="font-l col-2 fx-ccc outer">
                    <div className="w-90 fx-d-r fx-fec"  onClick={()=>{
                            login("Enter")
                        }}>
                        <div className="w-50 bd-rad-lr bd-black pad-5 b t account_pointer login" >
                            {t("GLOBAL.LOGIN")}
                        </div>
                    </div>

                </div>

                {/* choose language */}
                <div className = "col-2 fx-ccc outer btm">
                    <div className="w-90 pad-15 r font-l">
                        <Dropdown
                            index={"0"}
                            data={DP_data}
                            toggleDropdown={toggleDropdown}
                            closeToggle={dropdown_open}
                            returnData = {setReturnLng}/>
                    </div>
                </div>

                {/* login */}
                {/* login */}
                <div className="col-2 fx-cfe">{markC} {year} {t("GLOBAL.BRAND")}</div>
            </div>
        </div>
    );

}
export default LoginMobile;